export default "__VITE_ASSET__8ee6416e__"